import apiClient from "./apiClient";

export const getOffices = () => apiClient.get("/offices");
export const getOfficesByCompanyId = (companyId) => apiClient.get(`/offices/company/${companyId}`);
export const getOfficeById = (id) => apiClient.get(`/offices/${id}`);
export const createOffice = (data) => apiClient.post("/offices", data);
export const updateOffice = (id, data) => apiClient.put(`/offices/${id}`, data);
export const deleteOffice = (id) => apiClient.delete(`/offices/${id}`);
